<template>
    <div class="course">
        <div class="top">
            <a href="javascript:history.go(-1);" class="back" v-if="isUa">
                <i class="el-icon-arrow-left"></i>
            </a>
            {{name}}
            <!--<a href="#/selectjc" class="right" @click="changeJC()">
                切换
            </a>-->
        </div>
        <!--<div class="s_banner">
            <img src="../../assets/images/s_banner_2.jpg" alt=""/>
        </div>-->
        <div class="no-data-pad" v-if="list.length === 0"></div>
        <div class="line" v-if="list.length > 0"></div>
        <ImgList :list="list"></ImgList>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp'
import ImgList from './imgList'
import Loading from "../loading"

export default{
    name: 'Course',
    data(){
        return{
            title: '',
            name: '',
            currentpage: 1,
            subject: this.$route.params.id,
            grade:this.$route.params.grade,
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            structCode:'',
            list: [],
            books:[]
        }
    },
    computed:{
    },
    created(){
        this.getBooks(this.grade,this.subject);
        //this.getData();
    },
    mounted(){
        this.getStatistPv();
    },
    methods:{
        changeJC(){

        },
        getBooks(grade,subject){
             this.isLoading = true;
             //this.structCode='RJCZ020110';
             jsonp(`http://byte.gxnews.com.cn/php/qdapi.php?action=books&gradeId=${grade}&subjectId=${subject}`, {} , (err, data) => {
                 if (err) {
                     console.error(err.message);
                 } else {
                     this.isLoading = false;
                     console.log(data.data);
                     data.data.forEach(version => {
                         console.log(version);
                         version.books.forEach(book=>{
                             if(this.structCode==''){
                                this.structCode=book.bookCode;
                             }
                             if(this.name==''){
                                this.name=version.versionName+book.bookName;
                             }
                             this.books.push({name:version.versionName+book.bookName,bookCode:book.bookCode});
                         })
                     });
                     //this.books ;
                 }
                 console.log(this.books);
                 this.getData();
             })
        },
        getData(){
             this.isLoading = true;
             //this.structCode='RJCZ020110';
             jsonp(`http://byte.gxnews.com.cn/php/qdapi.php?action=resources&structCode=${this.structCode}&pagenu=${this.currentpage}`, {} , (err, data) => {
                 if (err) {
                     console.error(err.message);
                 } else {
                     this.isLoading = false;
                     this.list = data.data.list.map(item=>{
                         item.bookname = this.name;
                         return item;
                     });
                     this.currentpage+=1;
                 }
                 console.log(this.list);
             })
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fweikelist%2f${this.grade}%2f${this.subject}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }
    },
    components:{
        ImgList,
        Loading    
    }
}
</script>

<style lang="less" scoped>
    .course{
        padding-top: 0.6rem;
        .s_banner{
            margin-bottom: 0.35rem;
            img{
                width: 100%;
            }
        }
        .line{
            height: 0.25rem;
            margin: 0.2rem 0 0.3rem 0;
            background: #f3f3f3;
        }
        .no-data-pad{
            padding-bottom: 1.5rem;
        }
        .top{
            position: fixed;
            width: 100%;
            height: 1rem;
            line-height: 1rem;
            text-align: center;
            background: #fff;
            font-size: 0.43rem;
            font-weight: bold;
            color: #1960ab;
            left: 0;
            top: 0;
            z-index: 10;
            border-bottom: 1px solid #f1f1f1;
            .back{
                position: absolute;
                top: 0;
                left: 0.3rem;
                font-size: 0.6rem;
                color: #333;
            }
            .right{
                position: absolute;
                top: 0;
                right: 0.3rem;
                font-size: 0.4rem;
                color: #333;
            }
        }
    }             
</style>   